import {
    LightMapIcon,
    SatelliteMapIcon,
    WhiteMapIcon,
    DarkMapIcon,
    // need to import directly, as there is a infinite auto-load loop somewhere...
} from "themes/default-tailwind/icons"

import LightMapStyleJSON from "../map-themes/light"
import WhiteMapStyle from "../map-themes/white"
import SatelliteMapThemeJSON from "../map-themes/satellite"
import DarkMapStyleJSON from "../map-themes/dark"
import store from "integrations/redux/store"
import { selectActivatedFire } from "./selectors"
import { get } from "nodash"
import { takeMapSnapshot } from "../module"
import { MapStyleNames } from "./mapBackground"

export { MapStyleNames } from "./mapBackground"

export type MapStylesType = {
    [name: string]: {
        name: MapStyleNames
        url: string | object
        icon: typeof LightMapIcon
        contrast: ContrastTypes
    }
}

// if your component is generally darker, then we need for example light borders around it to highlight it
// so think of this as "My component is dark, so it is of the ContrastTypes.Dark"
// then it will be up to the parent component to modulate its rendering based on what type of child component it gets
export enum ContrastTypes {
    Dark = "dark",
    Light = "light",
}

// const maptilerKey = process.env.NEXT_PUBLIC_MAPTILER_API_KEY

export const mapStyles: MapStylesType = {
    [MapStyleNames.Light]: {
        name: MapStyleNames.Light,
        url: LightMapStyleJSON,
        icon: LightMapIcon,
        contrast: ContrastTypes.Light,
    },
    [MapStyleNames.Satellite]: {
        name: MapStyleNames.Satellite,
        url: SatelliteMapThemeJSON,
        icon: SatelliteMapIcon,
        contrast: ContrastTypes.Dark,
    },
    [MapStyleNames.White]: {
        name: MapStyleNames.White,
        url: WhiteMapStyle,
        icon: WhiteMapIcon,
        contrast: ContrastTypes.Light,
    },
    [MapStyleNames.Dark]: {
        name: MapStyleNames.Dark,
        url: DarkMapStyleJSON,
        icon: DarkMapIcon,
        contrast: ContrastTypes.Dark,
    },
}
export const defaultStyleOrder = [MapStyleNames.Light, MapStyleNames.Satellite]

export const getDefaultMapStyle = () => mapStyles[defaultStyleOrder[0]]

// defines all attributes required for the PartialViewState type
export const storedViewStatePropNames = [
    "longitude",
    "latitude",
    "zoom",
    "pitch",
    "bearing",
    "altitude",
    "width",
    "height",
]

export const decideTakeSnapshotOfSecondaryLayer = () => {
    const state = store.getState()
    const project = selectActivatedFire(state)
    const thumbnailViewState = get(project, "thumbnailViewState")
    if (!thumbnailViewState && project) {
        takeMapSnapshot(project.id)
    }
}
